export default "__VITE_PUBLIC_ASSET__6d85cecd__"